import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cb_form_text_with_title = _resolveComponent("cb-form-text-with-title")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_cb_form_text_with_title, {
        "cb-id": _ctx.cbId,
        "cb-type": "ORDER_LABEL_ASSIGNED_BY_DOCTOR",
        "is-normal-content-block": "",
        "is-publishable": "",
        mode: _ctx.mode,
        "return-route": {name: 'order-label-content-blocks'},
        title: _ctx.mode === _ctx.PageDetailModeEnum.NEW ? _ctx.$t('newCb') : _ctx.$t('editCb'),
        description: _ctx.$t('descriptionOrderLabelCbDetail'),
        description2: _ctx.$t('publishedText'),
        description3: undefined,
        description4: _ctx.$t('sortWeightDescription')
      }, null, 8, ["cb-id", "mode", "title", "description", "description2", "description4"])
    ]),
    _: 1
  }))
}